module.exports = __webpack_public_path__ + "static/media/4@960w.49fab638.jpg";